import React from "react";
import { Item, ItemStatuses, ItemTypes } from "../../data/ItemOfBusiness";

interface BusinessItemCardProps {
  item: Item | null;
  children: any;
}

export function statusChipClass(status: string): string {
  switch (status) {
    case ItemStatuses.New:
      return "sl-chip-status-new";
    case ItemStatuses.Voting:
      return "sl-chip-status-voting";
    case ItemStatuses.Voted:
      return "sl-chip-status-voted";
    case ItemStatuses.Accepted:
      return "sl-chip-status-accepted";
    case ItemStatuses.Abandoned:
      return "sl-chip-status-abandoned";
    default:
      return "sl-chip-type";
  }
}

function BusinessItemCard({ item, children }: BusinessItemCardProps) {
  if (!item) {
    return (
      <div className="card mb-3">
        <div className="card-header">No Current Item of Business</div>
        {children}
      </div>
    );
  }

  const typeLabel = item.type === ItemTypes.Amendment && item.status === ItemStatuses.New ? "Marked-up text under debate" : item.type;

  return (
    <div className="card mb-3">
      <div className="card-header">
        <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
          <span className="sl-chip sl-chip-code">Item {item.code}</span>
          <span className="sl-chip sl-chip-type">{typeLabel}</span>
          <span className={`sl-chip ${statusChipClass(item.status)}`}>{item.status}</span>
        </div>
        <div>{item.heading}</div>
      </div>
      {children}
    </div>
  );
}

export default BusinessItemCard;
